import {
    useQuery,
} from '@tanstack/react-query'

import {
    useJWTToken,
} from 'app/Auth'
import {
    useArchivedTableControl,
} from 'app/shared-components/TableControls/ShowArchived'
import loadFilters from 'app/common/DomainObject/hooks/useLoadFilters/loadFilters'
import useGetUntypedEnumLabel from 'app/hooks/useEnumValues/useGetUntypedEnumLabel'

type LoadFiltersParams = {
    keyForArchived?: string,
    baseUrl: string,
    filterField: string,
    preDefinedFilters?: object,
}

const useLoadFilterArrayOptions = <T = any>({
    keyForArchived,
    baseUrl,
    filterField,
    preDefinedFilters,
}: Readonly<LoadFiltersParams>) => {
    const getLabels = useGetUntypedEnumLabel()
    const showArchived = useArchivedTableControl(keyForArchived, true)
    const token = useJWTToken()
    const placeholderDataFnToKeepPreviousData = (prev) => {
        return prev
    }
    const payload = {
        token,
        columnInfo: {
            filterField,
        },
        props: {
            archived: keyForArchived ? showArchived : undefined,
            ...preDefinedFilters,
        },
    }

    return useQuery<T>({
        queryKey: [
            `${baseUrl}-${filterField}`,
            payload,
            baseUrl,
        ],
        queryFn: () => {
            return loadFilters({
                params: payload,
                customUrl: baseUrl,
                getLabels,
            })
        },
        refetchOnWindowFocus: false,
        retry: false,
        placeholderData: placeholderDataFnToKeepPreviousData,
        refetchInterval: false,
        refetchIntervalInBackground: false,
        staleTime: 10000, // important to prevent irrelevant calls,
    })
}

export default useLoadFilterArrayOptions
